import axios from "axios";
import constants from "./constants";
import moment from "moment";
import { CookieStorage } from "cookie-storage";
const cookieStorage = new CookieStorage();

export default {
  setupInterceptors: () => {
    axios.interceptors.request.use(
      (config) => {
        const token = cookieStorage.getItem(constants.API_TOKEN);
        const apiUrl = constants.API_URL;
        config.timeout = 60000;
        config.url = `${apiUrl}${config.url}`;
        config.headers.Authorization = token;
        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
    axios.interceptors.response.use(
      async (response) => {
        const newToken = response.data.Token;
        if (newToken !== "-1" && newToken !== "" && newToken !== null) {
          cookieStorage.removeItem(constants.API_TOKEN);
          cookieStorage.setItem(constants.API_TOKEN, newToken, { path: "/" });
          cookieStorage.removeItem(constants.TOKEN_SET_TIME);
          cookieStorage.setItem(constants.TOKEN_SET_TIME, moment().valueOf(), {
            path: "/",
          });
        }
        return response;
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  },
};
